import "./App.scss";
import { Routes, Route } from "react-router-dom";
import Home from "../../pages/Landing";
import Events from "../../pages/Events";

function App() {
  return (
    <div className="App">
     <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Events" element={<Events />} />
        {/* <Route path="/fundraiser" element={<Fundraiser />} />
        <Route path="/history" element={<History />} />
        <Route path="/contact" element={<Contact />} /> */}
      </Routes>
    </div>
  );
}

export default App;
